import * as React from "react";
import JustificativasTopo from "./topo";
import { JustificativasDetalhe } from "./detalhe";
import { JustificativasBottom } from "./bottom";
import Utils from "../../helper/utils";
import { useTranslation } from "react-i18next";

export const JustificativasPage = () => {
  const { t } = useTranslation();

  Utils.setDocumentTitle(t("pages.justifications.titlePage"));

  return (
    <React.Fragment>
      <JustificativasDetalhe />
      <JustificativasBottom />
    </React.Fragment>
  );
};
